import { render, staticRenderFns } from "./enterstudyResult.vue?vue&type=template&id=6a08bc67&scoped=true&"
import script from "./enterstudyResult.vue?vue&type=script&lang=js&"
export * from "./enterstudyResult.vue?vue&type=script&lang=js&"
import style0 from "./enterstudyResult.vue?vue&type=style&index=0&id=6a08bc67&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08bc67",
  null
  
)

export default component.exports